import { v5 as uuidv5 } from 'uuid';

export const createInternalManifest = (
	src: string = ''
): Promise<{
	canvasId: string;
	manifestId: string;
}> => {
	const uuid = uuidv5(src, uuidv5.DNS);

	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = (e) => {
			const manifest = {
				'@context': 'http://iiif.io/api/presentation/3/context.json',
				id: `@reframe-internal/${uuid}/manifest.json`,
				type: 'Manifest',
				items: [
					{
						id: `@reframe-internal/${uuid}/canvas/1`,
						type: 'Canvas',
						width: img.width,
						height: img.height,
						items: [
							{
								type: 'AnnotationPage',
								items: [
									{
										type: 'Annotation',
										motivation: 'painting',
										body: {
											id: src,
											type: 'Image',
											format: 'image/jpeg',
										},
										target: `@reframe-internal/${uuid}/canvas/1`,
									},
								],
							},
						],
					},
				],
			};
			resolve({
				canvasId: `@reframe-internal/${uuid}/canvas/1`,
				manifestId: 'data:application/json;base64,' + btoa(JSON.stringify(manifest)),
			});
		};
		img.onerror = (err) => reject(err);
		img.src = src;
	});
};
